import React, {Component} from 'react';
import DataChartComponent from './DataChartComponent';

export default class TopSuppliersContractValue extends Component {
    render() {
        return (
            <div className="x_panel">
                <div className="x_title">
                    <h2>
                        <i className="fa fa-angle-right"></i> {window.__js_dashboard.top_suppliers_contract_value}
                    </h2>
                    <div className="clearfix"></div>
                </div>
                <div className="x_content">
                    <DataChartComponent data={this.props.data}/>
                </div>
            </div>
        );
    }
}
